import { render, staticRenderFns } from "./problem-close.vue?vue&type=template&id=5ece4943&scoped=true&"
import script from "./problem-close.vue?vue&type=script&lang=js&"
export * from "./problem-close.vue?vue&type=script&lang=js&"
import style0 from "./problem-close.vue?vue&type=style&index=0&id=5ece4943&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece4943",
  null
  
)

export default component.exports